import { render, staticRenderFns } from "./GestionCatecumenos.vue?vue&type=template&id=64d9083b&"
import script from "./GestionCatecumenos.vue?vue&type=script&lang=js&"
export * from "./GestionCatecumenos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports